(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/bingo-react/components/use-start-timer/assets/javascripts/use-start-timer.js') >= 0) return;  svs.modules.push('/modules/bingo-react/components/use-start-timer/assets/javascripts/use-start-timer.js');
"use strict";

const {
  useState,
  useEffect
} = React;
const useInterval = svs.components.lbUtils.useInterval;
const {
  GameRoomStatus
} = svs.bingo_react.components.common.constants;
const useStartTimer = (startTime, status) => {
  const [timer, setTimer] = useState(null);
  const intervalId = useInterval(() => {
    const startDate = new Date(startTime);
    const duration = dateFns.intervalToDuration({
      start: new Date(),
      end: startDate
    });
    setTimer(duration);
  }, 1000, true, startTime);
  useEffect(() => {
    if ((timer === null || timer === void 0 ? void 0 : timer.minutes) === 0 && (timer === null || timer === void 0 ? void 0 : timer.seconds) === 0 || status === GameRoomStatus.STARTING) {
      clearInterval(intervalId);
      setTimer(null);
    }
  }, [timer, intervalId, status]);
  return timer;
};
setGlobal('svs.bingo_react.components.useStartTimer', useStartTimer);

 })(window);